export default __webpack_public_path__ + "static/media/meter4.d7f4c9b2.jpg";